import React, { Component } from "react";
import { connect } from 'react-redux';
import * as url from '../../../utils/url';
import axios from '../../../axios';
import * as actionCreators from '../../../modules/actions/index';
import MapVeteran from '../../../components/OrganizationSetup/MapVeteran/MapVeteran';
import EnterpriseBreadcrumb from '../../../components/EnterpriseBreadcrumb/EnterpriseBreadcrumb';

class MapVeteranManagement extends Component {
  // constructor(props) {
  //   super(props);
  // }

  componentDidMount() {
    window.scrollTo(0, 0);
    const {organizationId} = this.props.user;
    console.log("did mount management")
    axios.get(url.getExistingMappings(organizationId._id)).then(({data}) => {
      const payload = data.data;
      console.log(payload)
      const {veteran} = payload.mapping;
      if(veteran && veteran.columnName) {
        this.props.onMatchColumn(veteran.columnName);
      }
      const veteranData = veteran.data;
      let allMapping = []
      veteranData.forEach((c) => {
        const mapping = c.values.map((v) => {
          return {
            value : v,
            column : {
              label : c.reference.name,
              value : c.reference._id
            }
          }
        })
        allMapping = allMapping.concat(mapping);
      })
      this.props.saveAllVeteranMapping(allMapping);
    })
  }

  componentWillUnmount() {
    this.props.resetMapVeteranStep();
  }

  handleFileUpload = (columns, data, file) => {
    console.log(columns, data, file)
    this.props.onFileDataProcessed(columns, data, file);
  }

  handleMatchColumn = (matchedColumn) => {
    this.props.onMatchColumn(matchedColumn);
  }

  handleSkipMapping = () => {
    // console.log('Skip performance mapping');
  }

  render() {
    return (
      <div className="mt60 enterprise-map-page">
      <EnterpriseBreadcrumb 
        linkText="Enterprise Management" 
        link="/home/enterprise-info" 
        activeText="Map Veteran Status"
        {...this.props}
        />
      <MapVeteran
        onProcessedFileUploadData={this.handleFileUpload}
        onSkipVeteranMapping={this.handleSkipMapping}
        isRepeatFlow={true}
        {...this.props}/>
      </div>
    );
  }
}

const mapStateToProps = state => {
  console.log(state)
  return {
    user: state.user.profile,
    mapVeteran : state.mapping.veteran
  }
}

const mapDispatchToProps = dispatch => {
	return {
    resetMapVeteranStep: () => dispatch(actionCreators.resetMapVeteranStep()),
    nextStep: () => dispatch(actionCreators.mapVeteranNextStep()),
    goBack : () => dispatch(actionCreators.mapVeteranGoBack()),
    reset : () => dispatch(actionCreators.resetVeteran()),
    saveAllVeteranMapping : (o,s) => dispatch(actionCreators.saveAllVeteranMapping(o,s)),
    onFileDataProcessed: (c,d,f) => dispatch(actionCreators.mapVeteranUploadFileSuccess(c,d,f)),
    onMatchColumn: data => dispatch(actionCreators.mapVeteranMatchColumnSuccess(data))
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(MapVeteranManagement);